<div class="directory-page-container">
  <div class="combined-header">
    <public-header [providerPracticeState]="emptyURIValue"></public-header>
    <div class="find-by-filters">
      <h1 class="header-title" data-test="find-a-provider-header">
        Find a Provider
      </h1>
    </div>
  </div>

  <main>
    <div class="scrollable-area">
      <div *ngFor="let state of statesList">
        <ul class="states-item">
          <a
            class="state-name"
            [routerLink]="[
              '/',
              uriPrefix.STATE + '-' + state.abbreviation.toLocaleLowerCase(),
              uriPrefix.CITY + '-' + emptyURIValue,
            ]"
          >
            {{ state.name }}
          </a>
          <li class="subtitle">
            <a
              [routerLink]="[
                '/browse',
                uriPrefix.STATE + '-' + state.abbreviation.toLocaleLowerCase(),
              ]"
            >
              Browse Providers
            </a>
          </li>
        </ul>
      </div>
    </div>
  </main>

  <public-footer></public-footer>
</div>
